import React from "react";
import { Route, Redirect } from "react-router-dom";
import { Auth } from "aws-amplify";
import decode from "jwt-decode";
import Cookies from "universal-cookie";
import { getCurrentJwt } from "./util/jwt/decryptToken";

const cookies = new Cookies();
class ProtectedRoute extends React.Component {
  state = {
    loaded: false,
    isAuthenticated: false
  };
  componentDidMount() {
    this.authenticate();
  }

  authenticate() {
    Auth.currentAuthenticatedUser()
      .then(() => {
        this.setState({ loaded: true, isAuthenticated: true });
      })
      .catch(e => {
        this.setState({ isAuthenticated: false });
        localStorage.clear();
        window.location.href = "/";
      });
    if(localStorage.getItem('jwtToken') != null){
      let decoded_exp = decode(getCurrentJwt()).exp
      if(Date.now() >= decoded_exp * 1000){
        cookies.remove("Qlik-Ticket-CMP", {
          path: "/",
          domain: ".cmp.io"
        });
        cookies.remove("X-Qlik-Session-CMP", {
          path: "/",
          domain: ".cmp.io"
        });
        cookies.remove("X-Qlik-Session", {
          path: "/",
          domain: ".cmp.io"
        });
        cookies.remove("X-Qlik-Session", {
          path: "/",
          domain: process.env.REACT_APP_QLIKURL,
          httpOnly: true,
          secure: true
        });
        localStorage.clear();
      }
    }
    else{
      localStorage.clear();
    }
    /*Auth.currentSession().then(response => {
      localStorage.setItem("jwtToken", response.idToken.jwtToken);
    })
    .catch(e => {localStorage.clear()});*/
  }
  render() {
    const { component: Component, ...rest } = this.props;
    const { loaded, isAuthenticated } = this.state;
    if (!loaded) return null;
    return (
      <Route
        {...rest}
        render={props => {
          return isAuthenticated ? (
            <Component {...props} />
          ) : (
            <Redirect to="/" />
          );
        }}
      />
    );
  }
}
export default ProtectedRoute;



// WEBPACK FOOTER //
// ./src/ProtectedRoute.js